/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PersonIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M9.5,13.196 L9.5,16 L4.491,17.789 C3.297,18.216 2.5,19.347 2.5,20.614 L2.5,22.5 L21.5,22.5 L21.5,20.614 C21.5,19.347 20.703,18.216 19.509,17.789 L14.5,16 L14.5,13.196" />
      <ellipse cx="12" cy="8" rx="5" ry="6" />
      <path d="M16.953,7.453 C16.785,7.474 16.669,7.467 16.5,7.5 C14.797,7.828 13.703,7.211 12.766,5.57 C12.203,6.648 10.444,7.5 9,7.5 C8.289,7.5 7.677,7.354 7.064,7.034" />
    </g>
  </svg>
);

export default PersonIcon;
